<style>
.ivu-radio-group{
  display: block;
  margin-bottom: 10px;
}
</style>
<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Breadcrumb :style="{margin: '5px 0'}">
        <BreadcrumbItem>音频解析 > <b>解析列表</b></BreadcrumbItem>
      </Breadcrumb>
      <Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
            <span class="search_span_width">
                <span class="search_span_width_part1">状态：</span>
             <Select v-model="search.status" style="width:260px">
				 <Option value="0">全部</Option>
                    <Option value="1">解析中</Option>
					<Option value="2">解析成功</Option>
					<Option value="-1">解析失败</Option>
                </Select>
            </span>
        <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getVoiceList(1)">搜索</Button>
      </Card>
      <Card>
        <p :style="{'margin':'5px 10px 10px 20px','clear':'both','overflow':'hidden'}">
			<span :style="{'text-align':'center','float':'left'}">
				<Button type='primary' :style="{'margin-left':'5px'}" @click="addVoiceModal()">添加音频</Button>
			</span>
        </p>
        <Card id="tableContent" >
          <Table :columns="tableColumns" :data="voice_list"></Table>
          <Page :total="recordTotal" :current="page" :page-size="10" :show-elevator="true" @on-change="getVoiceList"/>
        </Card>
      </Card>
    </Content>
   
   <Modal v-model="showmodal" :footer-hide=true title="上传音频">
        <Form ref="voice" :model="voice" :label-width="80" :rules="voiceRule" >
            <FormItem label="音频名称" prop="voice_name">
                <Input placeholder="上传文件自动取文件名"  v-model="voice.voice_name"/>
            </FormItem>
            <FormItem label="音频地址" prop="logo">
				<audio ref="audio" controls="controls" width='100%' height="100%"></audio>
                <Upload :action="getUploadUrl" :headers="uploadHeader" :on-success="successUpload">
                    <Button icon="ios-cloud-upload-outline">上传音频</Button>
                </Upload>
            </FormItem>  
            <FormItem>
                <Button type="primary" @click="updateVoice()">提交</Button>
            </FormItem>
        </Form>
    </Modal>
	 <Modal v-model="showContent" width="500" ok-text="复制" @on-ok="onCopy">
		<p>
		    <Input v-model="content" prop="content" type="textarea" disabled  :rows="20"  />
		</p>
	</Modal>
  </Layout>
</template>
<script>
export default {
  data(){
    return {
      search : {
        status:''
      },
	  content:'',
	  showContent:false,
      showmodal:false,
      voice_list:[],
      recordTotal:0,
      page:1,
	  voice:{
		  id:0,
		  voice_name:"",
		  voice_url:'',
	  },
	  voiceRule :{
		  voice_name:[
             { required: true, message: "请输入音频名称", trigger: "blur" },
       ]
	  },
      tableColumns:[
        { title: 'ID', key: 'id', align: 'center' },
		{ title: '音频名称', key: 'voice_name', align: 'center'},
        { title: '音频', key: 'voice_url',
        	render:(h,params) =>{
        	   return h('span',{
        		 domProps: {
        		    innerHTML: '<audio controls="controls" style="width:150px;height:30px;"><source src="'+params.row.voice_url+'" type="audio/mpeg" /></audio>'
        		}
        	   })
        	}
         },
		{ title: '创建时间', key: 'created_at', align: 'center'},
		{ title: '状态', key: 'status', align: 'center',
			render:(h,params) =>{
				if (params.row.status == 1) {
					return h('span',{},'解析中');
				}else if(params.row.status == -1){
					return h('span',{},'解析失败');
				} else if (params.row.status == 2) {
					return h('span',{},'解析成功');
				} else if (params.row.status == 0) {
					return h('span',{},'未处理');
				}
			   
			}
		},
        { title: '操作', key: 'action', align: 'center',
          render: (h, params) => {
            let btns=[]
            btns.push(
                h('Button', {
                  props: { type: 'info', size: 'small' },
                  style: { marginRight: '5px', marginBottom: '5px' },
                  on: {
                    click: () => {
                      this.getVoiceInfo(params.row.id);
                    }
                  }
                }, '解析内容'),
            );
            return h("div",btns);
          }
        }
      ],
		uploadHeader:{
		  "Authorization":localStorage.getItem('token')
		},
    }
  },
  mounted:function(){
    this.getVoiceList();
  },
  computed:{
	  getUploadUrl(){
	      return process.env.VUE_APP_APIHOST+'/admin/material/upload';
	  }
  },
  methods:{
	addVoiceModal(){
		this.voice.id = 0;
		this.voice.voice_name = '';
		this.voice.voice_url = '';
		this.showmodal = true;
	},
	getVoiceList(page=this.page) {
		this.page = page;
		let p = {'page' : page}
		console.log(this.search)
		let params = Object.assign(this.search, p);
		this.http.get('/admin/material/voiceAnalysis',{params:params}).then(response=>{
		  let data=response.data;
		  if(data.code!==0)
		  {
			alert(data.message);
		  } else{
			this.voice_list = data.data.list;
			this.recordTotal = data.data.total;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
	getVoiceInfo(analysis_id){
		this.http.get('/admin/material/analysisInfo',{params:{'analysis_id':analysis_id}}).then(response=>{
		  let data=response.data;
		  if(data.code!==0)
		  {
			alert(data.message);
		  } else{
			this.content = data.data.content;
			this.showContent = true;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
    closeModal(){
      this.showmodal=false;
    },
	updateVoice(){
		this.http.post('/admin/material/analysisEdit',{
				  'voice_name':this.voice.voice_name,
				  'voice_url':this.voice.voice_url,
				  }).then(response=>{
		  let data=response.data;
		  if(data.code!==0){
		    this.$Message.error(data.message);
		    return false;
		  } else{
		    this.$Message.info(data.message);
		    this.showmodal = false;
			this.getVoiceList(this.page);
		    return true;
		  }
		});
	},
	successUpload(response, file, fileList){
		this.voice.voice_name = file.name;
	    let data=response
	    if(data.code!=0) {
	        this.$Message.error(data.message);
	        return true;
	    }
	    this.voice.voice_url=data.data.url;
		this.$refs.audio.src = data.data.url+"?ran=" + Math.random();
	},
	onCopy() {
	    navigator.clipboard.writeText(this.content).then(() => {
	        this.$Message.success('复制成功')
	    }).catch (err => {
              this.$Message.error("复制失败");
        })
	}
  }

}
</script>
<style>
	textarea[disabled],
	textarea:disabled,
	textarea.disabled {
	color: #2a2c2e;
	-webkit-text-fill-color: #2a2c2e;
	-webkit-opacity: 1;
	opacity: 1;
	}
	

</style>